import { EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CameleonService } from '~/app/shared/cameleon/cameleon.service';
var RadioGroupComponent = /** @class */ (function () {
    /**
       * Constructor
       */
    function RadioGroupComponent(cameleonService) {
        this.cameleonService = cameleonService;
        this._json = {
            "parameters": [
                {
                    "@name": "valuations",
                    "list": [
                        {
                            "pair": {
                                "left": {
                                    "cpe": ""
                                },
                                "right": {
                                    "ValuationList": {
                                        "@isCommentUserChoice": "false",
                                        "@isQtyUserChoice": "false",
                                        "@isValueUserChoice": "true",
                                        "Value": {
                                            "array": []
                                        },
                                        "Comment": null
                                    }
                                }
                            }
                        }
                    ]
                }
            ]
        };
        this._value = '';
        this.onChange = new EventEmitter();
    }
    Object.defineProperty(RadioGroupComponent.prototype, "fp", {
        get: function () { return this._fp; },
        set: function (data) {
            this._fp = data;
            this._json.parameters[0].list[0].pair.left.cpe = this.fp.id;
            this._value = this.fp.value[0];
            this._json.parameters[0].list[0].pair.right.ValuationList.Value.array[0] = { "pkValue": this._value };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadioGroupComponent.prototype, "value", {
        get: function () { return this._value; },
        set: function (data) {
            this._value = data;
            this._json.parameters[0].list[0].pair.right.ValuationList.Value.array[0] = { "pkValue": this._value };
            this.onChange.emit(this._json);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * On init
     */
    RadioGroupComponent.prototype.ngOnInit = function () {
    };
    /**
    * On destroy
    */
    RadioGroupComponent.prototype.ngOnDestroy = function () {
    };
    return RadioGroupComponent;
}());
export { RadioGroupComponent };
